export default function stripSubfamilyFromStyleName(
    styleName: string,
    subfamilyName: string,
): string {
    return styleName.replace(subfamilyName, '');
}
